module.exports = __webpack_public_path__ + "img/icon-notes.da9a426e.svg";